import { Check } from "lucide-react";
import { PlenaLogo } from "@/components/brand/PlenaLogo";
import { fmtDate } from "@/lib/api";
import { useEvaluation } from "./EvaluatorApp";

export default function DonePage() {
  const { ctx } = useEvaluation();
  return (
    <div className="flex min-h-screen flex-col" data-testid="completion-page">
      <header className="mx-auto flex w-full max-w-3xl items-center justify-between px-6 pt-8"><PlenaLogo height={26} /><span className="eyebrow">Aday Değerlendirmesi</span></header>
      <main className="fade-up mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center px-6 pb-24">
        <span className="mb-8 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#E6F7F1] text-plena-success"><Check className="h-6 w-6" /></span>
        <h1 className="font-heading text-4xl font-bold tracking-tight sm:text-5xl">Teşekkürler.</h1>
        <p className="mt-4 text-lg text-plena-text2" data-testid="completion-message">Değerlendirmeniz başarıyla tamamlandı.</p>
        <p className="mt-8 text-sm text-plena-muted">{ctx.job.title} · {ctx.progress.total} aday · Gönderim {fmtDate(ctx.submitted_at)}</p>
        <p className="mt-2 max-w-md text-sm text-plena-muted">Katkınız için teşekkür ederiz. Bu sayfayı kapatabilirsiniz.</p>
      </main>
    </div>
  );
}
